export const DELETE_LOCATION_FETCH_REQUEST = 'delete-location-fetch-request';
export const DELETE_LOCATION_FETCH_SUCCESS = 'delete-location-fetch-success';
export const DELETE_LOCATION_FETCH_FAILURE = 'delete-location-fetch-failure';